import React from 'react'
import {Link, SystemStyleObject, Text, TextProps} from '@chakra-ui/react'
import {breakTmLigature} from '_utils'

interface TextItemProps extends TextProps {
    text: string
    links?: Array<{title: string; link: string}>
    styles?: SystemStyleObject
}

const TextItem: React.FC<TextItemProps> = ({text, links, styles, ...props}) => {
    const replacePlaceholdersWithLinks = () => {
        const parts = text?.split(/(\{\d+\})/g)

        return (
            parts?.map((part, index) => {
                const match = part.match(/^\{(\d+)\}$/)
                if (match) {
                    const linkIndex = parseInt(match[1], 10)
                    const linkData = links?.[linkIndex]
                    if (linkData) {
                        return (
                            <Link key={index} href={linkData.link}>
                                {breakTmLigature(linkData.title, `link-${index}`)}
                            </Link>
                        )
                    }
                }
                return <React.Fragment key={index}>{breakTmLigature(part, `part-${index}`)}</React.Fragment>
            }) || text
        )
    }

    // Break the Safari "TM" -> "™" font ligature at render time (see breakTmLigature) without
    // altering the Page Designer text.
    const finalText = links && links.length > 0 ? replacePlaceholdersWithLinks() : breakTmLigature(text, 'text')

    return (
        <Text className="cc-text-item" sx={styles} {...props}>
            {finalText}
        </Text>
    )
}

export {TextItem}
